import m from "../../geodata/es2015/saintHelenaHigh";
window.am4geodata_saintHelenaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saintHelenaHigh.js
// module id = null
// module chunks = 